import { Injectable } from '@angular/core';
import { PaymentTypeAlias } from "app/common/models/coach-rate.model";

@Injectable({
  providedIn: 'root'
})
export class CoachesRateCalculateService {
  public coachSalaryCalculators: {
    [key in PaymentTypeAlias | 'salary' | 'other']: {
      aliasDisplayName: string,
      calc: (params: any) => number,
      edit: (params: any) => number,
      params: string[]
    }
  } = {
      "class": {
        aliasDisplayName: "Ставка за занятие",
        calc: this.calcSalaryClass,
        edit: this.calcSalaryClass,
        params: ["class"]
      },
      "personInGroup": {
        aliasDisplayName: "Ставка за человека",
        calc: this.calcSalaryPersonInGroup,
        edit: this.calcSalaryPersonInGroup,
        params: ["personInGroupRate", "personCount"]
      },
      "subscription": {
        aliasDisplayName: "За абонемент",
        calc: this.calcAboniment,
        edit: this.calcAboniment,
        params: ["subscriptions", "personCount"]
      },
      "pctWithMissed": {
        aliasDisplayName: "% от занятия, включая пропуски",
        calc: this.calcPctWithMissed,
        edit: this.calcPctWithMissed,
        params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount", "total"]
      },
      "pctWithoutMissed": {
        aliasDisplayName: "% от занятия без пропусков",
        calc: this.calcPctWithMissed,
        edit: this.calcPctWithMissed,
        params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount", "total"]
      },
      "progressiveRate": {
        aliasDisplayName: "Прогрессивная ставка",
        calc: this.calcProgressive,
        edit: this.calcProgressive,
        params: ["personCount", "total", "classesRate", "personsRate"]
      },
      "salary": {
        aliasDisplayName: "Оклад",
        calc: this.calcSalary,
        edit: this.editSalary,
        params: ["salary"]
      },
      "other": {
        aliasDisplayName: "Прочее",
        calc: this.calcAdditional,
        edit: this.calcAdditional,
        params: ["other"]
      },


      "withoutRate": {
        aliasDisplayName: "Ставка не найдена",
        calc: this.calcAdditional,
        edit: this.calcAdditional,
        params: ["personCount", "total"]
      }
    };

  constructor() {
    this.coachSalaryCalculators = {
      "class": {
        aliasDisplayName: "Ставка за занятие",
        calc: this.calcSalaryClass,
        edit: this.calcSalaryClass,
        params: ["class"]
      },
      "personInGroup": {
        aliasDisplayName: "Ставка за человека",
        calc: this.calcSalaryPersonInGroup,
        edit: this.calcSalaryPersonInGroup,
        params: ["personInGroupRate", "personCount"]
      },
      "subscription": {
        aliasDisplayName: "За абонемент",
        calc: this.calcAboniment,
        edit: this.calcAboniment,
        params: ["subscriptions", "personCount"]
      },
      "pctWithMissed": {
        aliasDisplayName: "% от занятия, включая пропуски",
        calc: this.calcPctWithMissed,
        edit: this.calcPctWithMissed,
        params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount", "total"]
      },
      "pctWithoutMissed": {
        aliasDisplayName: "% от занятия без пропусков",
        calc: this.calcPctWithMissed,
        edit: this.calcPctWithMissed,
        params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount", "total"]
      },
      "progressiveRate": {
        aliasDisplayName: "Прогрессивная ставка",
        calc: this.calcProgressive,
        edit: this.calcProgressive,
        params: ["personCount", "total", "classesRate", "personsRate"]
      },
      "salary": {
        aliasDisplayName: "Оклад",
        calc: this.calcSalary,
        edit: this.editSalary,
        params: ["salary"]
      },

      "other": {
        aliasDisplayName: "Прочее",
        calc: this.calcAdditional,
        edit: this.calcAdditional,
        params: ["other"]
      },


      "withoutRate": {
        aliasDisplayName: "Ставка не найдена",
        calc: this.calcAdditional,
        edit: this.calcAdditional,
        params: ["personCount", "total"]
      }
    };
  }

  public calcSalaryClass(params: any): number {
    return params['class'] || 0;
  }

  public calcSalaryPersonInGroup(params: any): number {
    return (params['personInGroupRate'] || 0) * (params['personCount'] || 0);
  }

  public calcPctWithMissed(params: any): number {
    let res = 0
    let _subs = params['details'];
    let _percent = params['subscriptionPercentRate'];
    let _unlimited = params['forUnlimitedRate']
    let _other = params['subscriptions'];
    let _total = params['total'];

    if (_other > 0) {
      res = _other
    }
    else if (_subs) {
      let _summ = 0;
      for (let _item of _subs) {
        if (_item.VisitCount < 10000) // если меньше 10 тысяч, то считаем по формуле, иначе прибавляем безлимит
        {
          let classVisitCount = _item.ClassVisitCount && _item.ClassVisitCount!==0 ? _item.ClassVisitCount : 1
          _summ += (_item.Price / _item.VisitCount) * classVisitCount * (_percent / 100)
        }
        else {
          _summ += _unlimited
        }
      }
      res = _summ
    }
    if (_total) {
      params['total'] = res;
    }
    return res;
  }
  public calcProgressive(params: any, type=""): number {
    try {
      const universalRate = params['universalRate'] || '';
      const [classesRateStr, personsRateStr] = universalRate.split('/');
      const classesCount = Number(params['classesCount']) || 0;
      const personCount = Number(params['personCount']) || 0;
      const parseRates = (rateStr: string) => {
        if (!rateStr) return [];
        return rateStr.split(';').map(item => {
          const [threshold, value] = item.split('=');
          return {
            threshold: parseInt(threshold, 10),
            value: parseInt(value, 10)
          };
        }).filter(rate => !isNaN(rate.threshold) && !isNaN(rate.value));
      };

      const calcClassValue = (rates: { threshold: number, value: number }[], count: number) => {
        const sortedRates = [...rates].sort((a, b) => b.threshold - a.threshold);
        const foundRate = sortedRates.find(rate => rate.threshold <= count);
        return foundRate ? foundRate.value : 0;
      };
      const calcPersonValue = (rates: { threshold: number, value: number }[], count: number) => {
        if (count <= 0) return 0;

        // Сортируем пороги по возрастанию
        const sortedRates = [...rates].sort((a, b) => a.threshold - b.threshold);

        let total = 0;
        let prevThreshold = 0;
        let prevValue = 0;
        for (const rate of sortedRates) {
          if (count <= rate.threshold) {
            total += (count - prevThreshold) * prevValue;
            return total;
          }

          total += (rate.threshold - prevThreshold) * prevValue;
          prevThreshold = rate.threshold;
          prevValue = rate.value;
        }

        // Добавляем оставшихся людей по последней ставке
        total += (count - prevThreshold) * prevValue;
        return total;
      };
      const classesRates = parseRates(classesRateStr);
      const personsRates = parseRates(personsRateStr);

      const classRate = calcClassValue(classesRates, personCount);
      const personRate = calcPersonValue(personsRates, personCount + 1);

      if (type=="person"){
        return personRate;
      }
      if (type=="class"){
        return classRate;
      }
      return classRate + personRate;

    } catch (ex) {
      console.error('Error in calcProgressive:', ex);
      return 0;
    }
  }
  // private parseRates(rateStr: string): {threshold: number, value: number}[] {
  //   var a = rateStr.split(';').map(item => {
  //     const [threshold, value] = item.split('=');
  //     return {
  //         threshold: parseInt(threshold),
  //         value: parseInt(value)
  //     };
  // });
  //   return rateStr.split(';').map(item => {
  //       const [threshold, value] = item.split('=');
  //       return {
  //           threshold: parseInt(threshold),
  //           value: parseInt(value)
  //       };
  //   });
  // }
  // private findRate(rates: {threshold: number, value: number}[], count: number): number {
  //   const sortedRates = [...rates].sort((a, b) => b.threshold - a.threshold);

  //   const foundRate = sortedRates.find(rate => rate.threshold <= count);

  //   return foundRate ? foundRate.value : 0;
  // }
  public calcAboniment(params: any): number {
    let res = 0
    let _subs = params['details'];
    let _percent = params['personInGroupRate'];  // subscriptionPercentRate
    let _unlimited = params['class']       // безлимит
    let _other = params['subscriptions'];
    if (_other > 0) {
      res = _other
    }
    else if (_subs) {
      let _summ = 0;
      for (let _item of _subs) {
        if (_item.VisitCount < 10000) // если меньше 10 тысяч, то считаем по формуле, иначе прибавляем безлимит
        {
          _summ += (_item.Price / _item.VisitCount) * (_percent / 100)
        }
        else {
          _summ += _unlimited
        }
      }
      res = _summ
    }
    params['subscriptions'] = res;
    return res;
  }

  public calcSalary(params: any): number {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    let _sum = 0
    if (params && params.details) {
      params.details.forEach(item => {
        let dt = new Date(item.dateTo.split('.').reverse().join('-'))
        let df = new Date(item.dateFrom.split('.').reverse().join('-'))
        let _countDays = Math.round(Math.abs((dt.getTime() - df.getTime()) / oneDay)) + 1; // прибавляю 1 т.к. с 1 дек. по 31 дек. он выдает 30 дней, а не 31
        let _daysInMounth = new Date(df.getFullYear(), df.getMonth() + 1, 0).getDate()
        let _oklad = item.salary * _countDays / _daysInMounth
        _sum += _oklad
      })
    }

    params['salary'] = _sum;
    return _sum;
    //return params['salary'] || 0;
  }

  public editSalary(params: any): number {
    return params['salary'] || 0;
  }

  public calcAdditional(params: any): number {
    return params['other'] || 0;
  }
  public basicParams: any = {
    "class": { paramDisplayName: "Ставка за занятие", paramType: "number" },
    "personInGroupRate": { paramDisplayName: "Ставка за занимающегося в группе", paramType: "number" },
    "personCount": { paramDisplayName: "Число занимающихся", paramType: "number" },
    "salary": { paramDisplayName: "Размер оклада", paramType: "number" },
    "total": { paramDisplayName: "Сумма", paramType: "number" },
    "duration": { paramDisplayName: "Продолжительность занятия", paramType: "number" },
    "other": { paramDisplayName: "Дополнительная сумма", paramType: "number" },
    "subscriptions": { paramDisplayName: "За абонемент", paramType: "number" },
    "forUnlimitedRate": { paramDisplayName: "Ставка за безлимитный абонемент", paramType: "number" },
    "subscriptionPercentRate": { paramDisplayName: "Процент за абонемент", paramType: "number" },
    "classesRate": { paramDisplayName: "Ставки за занятия", paramType: "text" },
    "personsRate": { paramDisplayName: "Ставки за занимающихся", paramType: "text" },
  };

public tooltipInfo: any = {
  "class": "Пример заполнения:<br> Кол-во участников | Стоимость занятия<br>от 2 | 100<br>от 4 | 200<br>от 8 | 400<br><br>Расшифровка:<br>от 2 до 3 подтвержденных записей — выплата тренеру: 100;<br>от 4 до 7 — 200;<br>от 8 и больше — 400.",
  "person": "Пример заполнения:<br> Кол-во участников | Сумма за 1 участника<br>от 1 | 100<br>от 8 | 200<br><br>Расшифровка: выплата тренеру по 100 за каждого участника в диапазоне от 1 до 7 человек; от 8 человек — по 200 за каждого участника.<br>Например, на занятии было 8 человек. Тренер получит: 7*100=700+200=900."
};
}
